import { render, staticRenderFns } from "./InvoiceCard.vue?vue&type=template&id=58ff5453&scoped=true&"
import script from "./InvoiceCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceCard.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCard.vue?vue&type=style&index=0&id=58ff5453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff5453",
  null
  
)

export default component.exports